import React from 'react';
import { t } from 'i18next';
import { cn } from '@/lib/utils';

const ComingSoonStats: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={cn("p-4", className)}>
      <div className="text-xs text-gray-500 text-center pt-2">
        {t('more_stats_coming')}
      </div>
    </div>
  );
};

export default ComingSoonStats;
